import { atom } from 'recoil';

export type listViewType = 0 | 1;
export const listViewStore = atom<listViewType>({
  key: 'listViewStore',
  default: 0,
});
